import { useAuth } from '../contexts/AuthContext';
import { Alert, Container, LoadingOverlay } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

const AdminRoute = ({ children }) => {
  const { isAdmin, loading, currentUser } = useAuth();

  if (loading) {
    return <LoadingOverlay visible={true} />;
  }

  if (!currentUser) {
    return (
      <Container size="sm" mt="xl">
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="No Autenticado"
          color="yellow"
        >
          Debe iniciar sesión para acceder a esta sección.
        </Alert>
      </Container>
    );
  }

  if (!isAdmin) {
    return (
      <Container size="sm" mt="xl">
        <Alert
          icon={<IconAlertCircle size={16} />}
          title="Acceso Denegado"
          color="red"
        >
          Esta sección solo está disponible para administradores.
        </Alert>
      </Container>
    );
  }

  return children;
};

export default AdminRoute;
